import React from "react";
import "./ScoreBoard.css";

const ScoreBoard = ({ score, totalQuestions }) => {
  const percentage =
    totalQuestions > 0 ? Math.round((score / totalQuestions) * 100) : 0;

  return (
    <div className="score-board">
      <div className="score">Score: {score}</div>
      <div className="total">Total Questions: {totalQuestions}</div>
      <div className="percentage">Success Rate: {percentage}%</div>
    </div>
  );
};

export default ScoreBoard;
